import { IconButton, IconButtonProps } from '@mui/material'

export const AcIconButton = (props: IconButtonProps) => {
  return <IconButton {...props} />
}
